import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const REGISTRATION_SUBMITTED = 'REGISTRATION_SUBMITTED';

export const useOnRegistrationSubmitted = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback(() => {
        const event = new CustomEvent(REGISTRATION_SUBMITTED);

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('registration:submitted', handleEvent);

        return () => publicEventsAPIService.off('registration:submitted', handleEvent);
    }, [handleEvent]);
};
